<template>
  <div
    v-show="gameModalOpen && isActive && gameTypeText"
    :key="updateTrigger"
    class="popup-wrap"
    :class="{ active: isActive && gameTypeText }"
  >
    <div class="popup-box">
      <div class="popup-container">
        <a class="popup-close" @click="hideModel" />
        <div class="form-popup popup-padding">
          <div class="modal-body">
            <!--eslint-disable-next-line -->
              <p class="h5 nl2br" v-html="gameTypeText" />
            <div class="row-frame">
              <div class="colu-12">
                <div class="form-check-frame">
                  <div class="checkbox-wrapper-40">
                    <label>
                      <input v-model="dontShowToday" for="DontShowSoday" type="checkbox">
                      <span id="DontShowSoday" class="checkbox">{{ $t('Bao.not_show_today') }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="popup-footer justify-content-center">
            <button type="button" class="btn btn-outline-primary-gold close-popup" @click="hideGame">
              {{ $t('Bao.submit') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isCrossDay } from '@/utils/tool'
import { page } from '@/api/common'
import { mapGetters } from 'vuex'
import { initializeGamePreferences } from '@/utils/games'

export default {
  name: 'BeforeGameOpenModal',
  props: {
    isActive: Boolean
  },
  data() {
    return {
      updateTrigger: 0,
      gameTypeText: '',
      dontShowToday: false
    }
  },
  computed: {
    ...mapGetters(['app']),
    gameModalOpen() {
      this.updateTrigger

      const currentTimeStamp = Math.floor(Date.now() / 1000)
      const storedTimeStamp = localStorage.getItem('lastPopupTimeStamp')

      // 如果 timestamp 已超過 24 小時就初始化
      if (storedTimeStamp && isCrossDay(currentTimeStamp, this.app.lastPopupTimeStamp)) {
        initializeGamePreferences()
      }

      let openModal = true
      const gameModalPreferences = JSON.parse(localStorage.getItem('gameModalPreferences'))
      const gameType = String(this.app.currentGame.type)

      // 先判斷今日有無勾選不要顯示彈窗
      if (gameType && gameModalPreferences && gameModalPreferences[gameType] && gameModalPreferences[gameType].dontShow) {
        // 再判斷時間
        if (storedTimeStamp && !isCrossDay(currentTimeStamp, this.app.lastPopupTimeStamp)) {
          openModal = false
          this.$store.commit('SET_MODAL_ACTIVE', false)
        }
      }

      return openModal
    }
  },
  watch: {
    'app.lastPopupTimeStamp'(newVal) {
      if (newVal) {
        this.openGameModal()
      }
    },
    isActive: {
      handler(newVal) {
        if (newVal) {
          this.updateTrigger++

          if (this.app.currentGame) {
            this.getTextFromGameType()
          }

          const gameModalPreferences = JSON.parse(localStorage.getItem('gameModalPreferences') || '{}')
          const gameType = this.app.currentGame.type

          if (gameModalPreferences && gameType && gameModalPreferences[gameType]) {
            this.dontShowToday = gameModalPreferences[gameType].dontShow || false
          } else {
            this.dontShowToday = false
          }
        }
      }
    }
  },
  created() {
    this.updateLastPopupTimeStamp()
  },
  methods: {
    hideModel() {
      this.$store.commit('SET_MODAL_ACTIVE', false)
    },
    hideGame() {
      this.hideModel()

      const currentTimeStamp = Math.floor(Date.now() / 1000)
      localStorage.setItem('lastPopupTimeStamp', currentTimeStamp.toString())
      this.$store.commit('SET_LAST_POPUP_TIMESTAMP', currentTimeStamp)

      const gameModalPreferences = JSON.parse(localStorage.getItem('gameModalPreferences') || '{}')
      const gameType = this.app.currentGame.type

      if (gameType) {
        if (!gameModalPreferences[gameType]) {
          gameModalPreferences[gameType] = {}
        }

        // 更新 dontShowToday
        gameModalPreferences[gameType].dontShow = this.dontShowToday
        localStorage.setItem('gameModalPreferences', JSON.stringify(gameModalPreferences))
      }
    },
    updateLastPopupTimeStamp() {
      const storedTimeStamp = localStorage.getItem('lastPopupTimeStamp')
      if (!storedTimeStamp) {
        this.$store.commit('SET_LAST_POPUP_TIMESTAMP', Math.floor(Date.now() / 1000))
      } else {
        this.$store.commit('SET_LAST_POPUP_TIMESTAMP', parseInt(storedTimeStamp, 10))
      }
    },
    openGameModal() {
      this.$store.commit('SET_GAME_URL', this.app.tempGameUrl)
    },
    async getTextFromGameType() {
      const isProduction = process.env.VUE_APP_ENV === 'production'
      const gameType = this.app.currentGame.type

      const typeMapProduction = {
        1: 'slot_rule_pop',
        2: 'live_rule_pop',
        10: 'skill_rule_pop',
        13: 'pachi_rule_pop',
        14: 'horse_rule_pop'
      }

      const typeMapDev = {
        1: 'slot_rule_pop',
        2: 'live_rule_pop',
        10: 'skill_rule_pop',
        12: 'pachi_rule_pop',
        13: 'horse_rule_pop'
      }

      const typeMap = isProduction ? typeMapProduction : typeMapDev
      const param = typeMap[gameType] || 'slot_rule_pop'

      try {
        await page({ type: param }).then(response => {
          this.gameTypeText = response.data.data.content
        })
      } catch (error) {
        this.gameTypeText = ''
      }
    }
  }
}
</script>
